import { render, staticRenderFns } from "./BlockArrange.vue?vue&type=template&id=56886c33"
import script from "./BlockArrange.vue?vue&type=script&lang=js"
export * from "./BlockArrange.vue?vue&type=script&lang=js"
import style0 from "./BlockArrange.vue?vue&type=style&index=0&id=56886c33&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports